import './index.scss'
import TokenizedRWAHead from './modules/TokenizedRWAHead'
import TokenizedRWAContent from './modules/TokenizedRWAContent'
import TokenizedRWAFoot from './modules/TokenizedRWAFoot'


const Home = () => {

 return (
  <div className={`tokenized-RWA`}>
    <TokenizedRWAHead />

    <TokenizedRWAContent />

    <TokenizedRWAFoot />

  </div>
 )
}

export default Home